"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Registration = Registration;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const antd_1 = require("antd");
const elements_1 = require("@src/components/elements");
const RegistrationForm_1 = require("./modules/RegistrationForm");
function Registration() {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsxs)(elements_1.Holder, { marginVertical: true, children: [(0, jsx_runtime_1.jsx)(antd_1.Row, { justify: "center", children: (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: { span: 24 }, lg: { span: 12 }, children: (0, jsx_runtime_1.jsx)(elements_1.Title, { level: 2, type: "secondary", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "registration.employer" }) }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Row, { justify: "center", children: (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: { span: 24 }, xl: { span: 18 }, children: (0, jsx_runtime_1.jsx)(elements_1.Panel, { children: (0, jsx_runtime_1.jsx)(RegistrationForm_1.RegistrationForm, { intl: intl }) }) }) })] }));
}
